import isNil from 'lodash/isNil';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from "react-router-dom";
import { answerQuestion } from '../actions';
import QuestionsList from '../components/QuestionsList'

const PageQuestionsList = () => {
  const questions = useSelector(state => state.questions);
  const answers = useSelector(state => state.answers);
  const { page = 1 } = useParams();
  const dispatch = useDispatch();
  return (
    <QuestionsList
      questions={questions[page]}
      answers={answers}
      answerQuestion={(questionKey, answer) => dispatch(answerQuestion(questionKey, answer))}
      firstUnansweredQuestionId={questions[page].find(questionId => isNil(answers[questionId]))}
    />
  );
};

export default PageQuestionsList;
